import React from 'react';
import SEO from '../components/SEO';
import './LegalPage.css';

const TermsAndConditions = () => {
  return (
    <div className="legal-page">
      <SEO
        title="Terms & Conditions – Remotix: Universal TV Remote"
        description="Read the Terms & Conditions for using Remotix: Universal TV Remote app and website."
      />
      <section className="page-hero">
        <div className="page-hero-bg">
          <div className="hero-glow hero-glow-1"></div>
        </div>
        <div className="page-hero-content">
          <span className="section-badge">Legal</span>
          <h1>Terms & <span className="gradient-text">Conditions</span></h1>
          <p>Please read these terms carefully before using our application.</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="legal-container">
          <p className="legal-updated">Last updated: March 26, 2026</p>

          <div className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By downloading, installing, or using Remotix: Universal TV Remote ("the App"), you agree to be bound by these
              Terms and Conditions. If you do not agree to these terms, please do not use the App.
            </p>
          </div>

          <div className="legal-section">
            <h2>2. Description of Service</h2>
            <p>
              Remotix: Universal TV Remote is a mobile application that allows users to control television sets, air
              conditioning units, and other compatible devices using WiFi connectivity and infrared (IR) blaster
              technology. The App also provides screen mirroring, screen casting, and IPTV playlist browsing features.
            </p>
          </div>

          <div className="legal-section">
            <h2>3. User Requirements</h2>
            <ul>
              <li>You must be at least 13 years of age to use the App.</li>
              <li>You are responsible for ensuring that your device is compatible with the App.</li>
              <li>Some features require an active WiFi connection or an IR blaster-equipped device.</li>
              <li>You agree to use the App only for lawful purposes and in accordance with these Terms.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>4. Intellectual Property</h2>
            <p>
              All content, features, and functionality of the App, including but not limited to software, text,
              graphics, logos, and icons, are the exclusive property of Remotix: Universal TV Remote and are protected by
              international copyright, trademark, and other intellectual property laws.
            </p>
          </div>

          <div className="legal-section">
            <h2>5. User Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the App to control devices that you do not own or have permission to control.</li>
              <li>Reverse engineer, decompile, or disassemble any part of the App.</li>
              <li>Use the App in any way that could damage, disable, or impair the service.</li>
              <li>Attempt to gain unauthorized access to any systems or networks connected to the App.</li>
              <li>Use the IPTV features to access copyrighted content without proper authorization.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>6. Third-Party Services</h2>
            <p>
              The App may contain links to or integrate with third-party services, including but not limited to
              Google Play Services, Firebase, and advertising networks. Your use of such services is subject to
              their respective terms and privacy policies. We are not responsible for the content or practices of
              any third-party services.
            </p>
          </div>

          <div className="legal-section">
            <h2>7. Advertisements</h2>
            <p>
              The App may display advertisements provided by third-party ad networks, including Google AdMob.
              These ads help support the free availability of the App. Ad content is provided by third parties
              and is not controlled by us.
            </p>
          </div>

          <div className="legal-section">
            <h2>8. IPTV Content</h2>
            <p>
              The App provides access to publicly available IPTV playlists and allows users to import custom
              playlists. We do not host, create, or control any IPTV content. Users are responsible for ensuring
              that their use of IPTV features complies with all applicable laws and regulations. We are not
              responsible for any content accessed through IPTV features.
            </p>
          </div>

          <div className="legal-section">
            <h2>9. Disclaimer of Warranties</h2>
            <p>
              The App is provided "as is" and "as available" without warranties of any kind, either express or
              implied. We do not guarantee that the App will be compatible with all devices, TV brands, or AC
              units. Device compatibility depends on hardware capabilities and manufacturer specifications.
            </p>
          </div>

          <div className="legal-section">
            <h2>10. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by applicable law, Remotix: Universal TV Remote shall not be liable for any
              indirect, incidental, special, consequential, or punitive damages, or any loss of profits or
              revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other
              intangible losses resulting from your use of the App.
            </p>
          </div>

          <div className="legal-section">
            <h2>11. Modifications to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon
              posting within the App or on our website. Your continued use of the App after changes constitutes
              acceptance of the modified Terms.
            </p>
          </div>

          <div className="legal-section">
            <h2>12. Termination</h2>
            <p>
              We may terminate or suspend your access to the App at any time, without prior notice, for conduct
              that we believe violates these Terms or is harmful to other users or third parties.
            </p>
          </div>

          <div className="legal-section">
            <h2>13. Contact Information</h2>
            <p>
              If you have any questions about these Terms and Conditions, please contact us at:
            </p>
            <p className="contact-email">
              <a href="mailto:support@universaltvremote.app">support@universaltvremote.app</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
